module.exports = __webpack_public_path__ + "static/img/xcx.b615c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/xcx.jpg
// module id = k/gn
// module chunks = 5